<template>
  <div></div>
</template>

<script>
export default {
  name: 'MilkOrderDetailPage'
}
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/pages/milk/order/MilkOrderDetailPage.vue